// extracted by mini-css-extract-plugin
module.exports = {"mainTitle":"ReservationEdit_mainTitle__OHUhX","infoAnnounce":"ReservationEdit_infoAnnounce__kopSl"};